import React, { useEffect, useState } from 'react';
import { fetchData } from '../../utils/api';
import { apiUrl } from '../../config';

const PasswordInput = ({ onSuccess }) => {
  const [users, setUsers] = useState([]);
  const [p, setP] = useState('');
  const [error, setError] = useState('');
  const [currentUser, setCurrentUser] = useState(0);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('accessToken');
      const result = await fetchData(`${apiUrl}/api/sys/opboad`, "GET", token);
      if (result.request.status === 0) {
        setUsers(result.request.users);
        setCurrentUser(result.request.currentUser || 0); // id вместо объекта
        setError('');
      } else {
        setError(result.request.message);
      }
    };

    fetchUsers();
  }, [setCurrentUser]);

  const handleSubmit = async () => {
    const token = localStorage.getItem('accessToken');
    const result = await fetchData(`${apiUrl}/api/sys/opboad`, "POST", token, { body: { uid: currentUser, p: p } });
    if (result.request.status === 0) {
      setError('');
      onSuccess(currentUser);
    } else {
      setError(result.request.message);
    }
  };

  return (
    <form className='system-form'>
      <div className='system-input-box d-flex'>
        <select
          value={currentUser}
          onChange={(e) => setCurrentUser(e.target.value)}
          style={{ marginRight: "10px" }}
        >
          {users.map(user => (
            <option key={user.id} value={user.id}>
              {user.first_name} {user.last_name}
            </option>
          ))}
        </select>
        <input
          type="password"
          value={p}
          onChange={(e) => setP(e.target.value)}
          placeholder="Введите пароль"
        />
        <button type="button" onClick={() => handleSubmit()} className="system-booking-table-btn system-booking-table-btn-edit">Открыть</button>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </form>
  );
};

export default PasswordInput;
